// extracted by mini-css-extract-plugin
export default {"item":"item--pk8Nr","input":"input--z3cGN","edit":"edit--VlrrX","bot":"bot--oPlhF","count":"count--Kqqi2","btn":"btn--Abu49"};